import script from "./GamePlanTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GamePlanTable.vue?vue&type=script&setup=true&lang=js"

import "./GamePlanTable.vue?vue&type=style&index=0&id=08b4fa4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b4fa4e"]])

export default __exports__